import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { heroBadges, heroChips, heroWorkflows } from '../data/hero';
export function Hero() {
  return <header className="relative overflow-hidden bg-navy text-white" data-id="element-96" data-mp="9kjuahxxms0i">
      <div className="mx-auto max-w-5xl px-5 pb-16 pt-10 text-center sm:pt-14" style={{
      paddingTop: "15px",
      paddingBottom: "26px"
    }} data-id="element-97" data-mp="9ip7ey33opts">
        <h1 className="mx-auto max-w-3xl font-display text-[30px] font-black leading-[1.1] sm:text-5xl lg:text-[56px]" data-id="element-98" data-mp="12a0kd8y2xwtk">
          Turn AI Into Your <span className="text-gold" data-id="element-99" data-mp="xaxejma9zmkj">Real Estate Assistant</span> in Minutes
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-white/75 sm:text-lg" data-id="element-100" data-mp="s9zxxe4wz0l5">
          The ultimate AI productivity system for REALTORS® who want ready-to-use prompts for leads, listings, follow-up,
          conversations and sales.
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto mt-10 w-full max-w-4xl" data-id="element-101" data-mp="381xkgw128y94">
          <div style={{
          marginTop: "-25px",
          marginBottom: "-25px"
        }} data-id="element-102" data-mp="3o6u71a6kmrcx">
            <img src="https://cdn.magicpatterns.com/uploads/wEnrVUBAEWaxKoSTqCBDHy/Kit_premium_de_herramientas_inmobiliarias_con_IA.webp" alt="THE REALTOR AI PLAYBOOK™ — 100 AI Prompts with 5 professional bonus volumes by SIGMA SMART™" width={1536} height={1024} sizes="(min-width: 1024px) 840px, 100vw" fetchPriority="high" decoding="async" className="animate-floaty mx-auto h-auto w-full object-contain" style={{
            width: "100%",
            paddingBottom: "10px"
          }} data-id="element-103" data-mp="399bc1q3avhx1" />
          </div>
        </motion.div>

        <div className="mt-8" data-id="element-104" data-mp="2vjzpom51w83o">
          <p className="font-display text-xl font-black tracking-tight sm:text-2xl" data-id="element-105" data-mp="2vj7rr4nzdya8">THE REALTOR AI PLAYBOOK™</p>
          <p className="mt-1 font-display text-lg font-extrabold sm:text-xl" data-id="element-106" data-mp="2hl9r122l20d7">
            <span className="text-gold" data-id="element-107" data-mp="2lk8wcns87z56">100 AI PROMPTS</span>{' '}
            <span className="font-semibold text-white/85" data-id="element-108" data-mp="s2b7hx6yyh4m">for Leads, Listings, Follow-Up & Sales</span>
          </p>
          <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs font-medium text-white/55" style={{
          paddingTop: "38px",
          marginTop: "-25px",
          marginBottom: "-25px"
        }} data-id="element-109" data-mp="najfrjc2u5cw">
            {heroBadges.map((b, i) => <li key={b} className="flex items-center gap-3" data-id="element-110" data-mp="deyhnwa4pp8f" data-mpi={i}>
                {i > 0 && <span className="h-1 w-1 rounded-full bg-cyan" aria-hidden="true" data-id="element-111" data-mp="1azkutpff0er5" />}
                {b}
              </li>)}
          </ul>
        </div>

        <div className="mx-auto mt-10 max-w-xl" data-id="element-112" data-mp="112pud0zl04a8">
          <p className="text-lg font-semibold text-white/60" data-id="element-113" data-mp="111eql164ywj4">Stop staring at a blank AI chat.</p>
          <p className="mt-1 font-display text-xl font-extrabold sm:text-2xl" data-id="element-114" data-mp="x0csworvasj9">Start using AI with a proven real estate workflow.</p>
          <div className="mt-6 flex justify-center" data-id="element-115" data-mp="3lquffqlsob64">
            <CTAButton href="#pricing" data-id="element-116" data-mp="3hqahwlxb75jg">See The Realtor AI Playbook™ now</CTAButton>
          </div>
        </div>

        <div className="mx-auto mt-14 max-w-3xl border-t border-white/10 pt-10" style={{
        paddingTop: "13px"
      }} data-id="element-117" data-mp="1xam54pmyxoye">
          <h2 className="font-display text-base font-black uppercase tracking-wide text-white sm:text-lg" data-id="element-118" data-mp="21b629t7jkskj">
            The AI command system for modern REALTORS®
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-[15px] leading-relaxed text-white/70" data-id="element-119" data-mp="2b1hl0lvvx6bh">
            Designed for REALTORS®, real estate agents, brokers and professionals who want to use AI across the everyday tasks
            that actually move their business forward.
          </p>

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-2 text-sm font-semibold text-white/90" data-id="element-120" data-mp="2p1jxfslfb7jc">
            {heroWorkflows.map((w, i) => <li key={w} className="flex items-center gap-4" data-id="element-121" data-mp="2txhc7uh1g5u0" data-mpi={i}>
                {i > 0 && <span className="h-1 w-1 rounded-full bg-gold" aria-hidden="true" data-id="element-122" data-mp="uo0shxp2cmo0" />}
                {w}
              </li>)}
          </ul>

          <ul className="mt-7 flex flex-wrap justify-center gap-2.5" data-id="element-123" data-mp="4bdxli20sdpo">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <li key={label} className="inline-flex items-center gap-2 rounded-full border border-white/15 px-3.5 py-1.5 text-xs font-medium text-white/80" data-id="element-124" data-mp="3vigo07a1afyu">
                <Icon className="h-3.5 w-3.5 shrink-0 text-cyan" aria-hidden="true" data-id="element-125" data-mp="e77j3qxpvhjl" />
                {label}
              </li>)}
          </ul>

          <p className="mt-6 text-sm text-white/50" data-id="element-126" data-mp="3hrbwxtkqew04">— Everything you need to put AI to work across your real estate workflow —</p>

          <div className="mt-6 inline-flex items-center rounded-full border border-gold/40 px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-gold" data-id="element-127" data-mp="3ct0nvl29gpiy">
            Limited-Time Launch Offer
          </div>
          <p className="mx-auto mt-4 max-w-xl text-[15px] text-white/75" data-id="element-128" data-mp="3mnahf62xvtv9">
            THE REALTOR AI PLAYBOOK™ gives you <span className="font-semibold text-white" data-id="element-129" data-mp="2yxg4koime5b0">100 specialized AI prompts</span>{' '}
            organized into a practical 6-volume system.
          </p>
        </div>
      </div>
    </header>;
}